// 版本监控
import { Modal } from 'ant-design-vue'
import { lang } from '@jms/utils'
const { VITE_APP_ASDFGHJKL } = import.meta.env
export const versionCheck = async (url: string) => {
  const timestamp = new Date().getTime()
  //import.meta.env.MODE 获取的是开发还是生产版本的
  if (import.meta.env.MODE === 'development') return
  fetch(`${url}?t=${timestamp}`)
    .then((res) => res.json())
    .then((resp) => {
      console.log('resp', resp)
      console.log('process.env.VITE__APP_VERSION__', process.env.VITE__APP_VERSION__)
      // eslint-disable-next-line no-undef
      //process.env.VITE__APP_VERSION__  获取环境变量设置的值，判断是否与生成的版本信息一致
      if (process.env.VITE__APP_VERSION__ !== resp.version) {
        // eslint-disable-next-line no-undef
        Modal.confirm({
          title: lang('发现新版本'),
          content: lang('检测到最新版本，刷新后立即使用...'),
          okText: lang('立即更新'),
          cancelText: lang('暂不更新'),
          onOk() {
            // 强制刷新：添加时间戳参数，防止浏览器缓存 index.html 导致死循环
            try {
              const url = new URL(window.location.href)
              url.searchParams.set('t', String(Date.now()))
              window.location.href = url.toString()
            } catch (error) {
              window.location.reload()
            }
          }
        })
      }
    })
}
